/** Tiny haptic tap; silently no-ops when unavailable. */
export function tap(pattern: number | number[] = 8) {
  if (typeof navigator === "undefined") return;
  const nav = navigator as Navigator & { vibrate?: (p: number | number[]) => boolean };
  try {
    nav.vibrate?.(pattern);
  } catch {
    /* no-op */
  }
}
